import React, { useState } from "react";
import API from "../Common/API";
import { useSelector, useDispatch } from "react-redux";
import { setAlert } from "../Store/Theme/actions";

const OTPField = ({ onSucess, onAbort,mobileNumber }) => {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const dispatch = useDispatch();

    const handleChange = (element, index) => {
        if (!/^\d*$/.test(element.value)) return; // Restrict to numbers only
        const updatedOtp = [...otp];
        updatedOtp[index] = element.value;
        setOtp(updatedOtp);

        if (element.value && index < otp.length - 1) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }
    };

    const handleKeyDown = (event, index) => {
        if (event.key === "Backspace" && !otp[index] && index > 0) {
            document.getElementById(`otp-input-${index - 1}`).focus();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let values = {
            mobileNumber: mobileNumber,
            otp: otp.join(""),
        };
        API.post("/common/verifyOTP", values)
            .then((verifyRes) => {
                if (verifyRes.status === 200) {
                    dispatch(
                        setAlert({
                            title: "Success",
                            subtitle: "OTP Verified Successfully",
                            active: true,
                            type: "success",
                        })
                    );
                    onSucess(true);
                } else {
                    dispatch(
                        setAlert({
                            title: "Error",
                            subtitle: "Incorrect OTP",
                            active: true,
                            type: "error",
                        })
                    );
                }
            })
            .catch(() => {
                dispatch(
                    setAlert({
                        title: "Error",
                        subtitle: "Incorrect OTP",
                        active: true,
                        type: "error",
                    })
                );
            });
    };

    const resendOTP = () => {
        API.get("/common/requestOTP").then(() => {
            setOtp(new Array(6).fill(""));
        });
    };

    return (
        <div className="flex w-full justify-center items-center h-96 bg-gray-100 dark:bg-[rgb(25,25,28)]">
            <div className="bg-white dark:bg-[rgb(25,25,28)] p-6 rounded-lg shadow-md w-full max-w-sm text-black dark:text-white">
                <h2 className="text-2xl font-bold mb-4 text-center">Enter OTP</h2>
                <p className="text-gray-500 dark:text-gray-300 text-center mb-6">
                    We’ve sent a code to your email Id
                </p>
                <form onSubmit={handleSubmit}>
                    <div className="flex justify-between space-x-2 mb-6">
                        {otp.map((data, index) => (
                            <input
                                key={index}
                                type="text"
                                id={`otp-input-${index}`}
                                maxLength="1"
                                value={data}
                                onChange={(e) => handleChange(e.target, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                className="w-12 h-12 text-center text-xl font-bold border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-[rgb(35,35,38)] text-black dark:text-white"
                            />
                        ))}
                    </div>
                    <button
                        type="submit"
                        className="w-full py-2 px-4 bg-nameColor hover:bg-nameColor-700 text-white font-semibold rounded-md transition duration-200 cursor-pointer"
                    >
                        Verify OTP
                    </button>
                </form>
                <p className="text-center text-gray-500 dark:text-gray-300 mt-4">
                    Didn’t receive the code?{" "}
                    <button
                        type="button"
                        className="text-blue-500 hover:underline"
                        onClick={resendOTP}
                    >
                        Resend
                    </button>
                </p>
            </div>
        </div>
    );
};

export default OTPField;
